module.exports = __webpack_public_path__ + "static/media/100.74391019.jpg";